var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_398",
    "data-name": "Pfad 398",
    d: "M18,0A18,18,0,1,0,36,18,17.981,17.981,0,0,0,18,0Zm0,2.25a16.047,16.047,0,0,1,9.9,3.487L5.737,27.788A15.679,15.679,0,0,1,18,2.25Zm0,31.5a16.047,16.047,0,0,1-9.9-3.488L30.15,8.1A15.762,15.762,0,0,1,18,33.75Z",
    fill: "#ff7600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.2abcd66defd09f74ed21d2bb03a070ac.svg";
export { ForwardRef as ReactComponent };